// @flow
/**
 * path to content service
 */
export const CONTENT_PATH = `/content`;

/**
 * Upload Path
 */
export const UPLOAD_PATH = `/uploadFile`;

/**
 * Captcha Path
 */
export const CAPTCHA_PATH = `/captchaServices`;

/**
 * Path to change avatar page / component
 */
export const CHANGEAVATAR_PATH = "/change-avatar";

/**
 * Path to change password page / component
 */
export const CHANGEPASSWORD_PATH = "/change-password";

/**
 * Path to user profile page / component
 */
export const USERPROFILE_PATH = "/user";

/**
 * Path to resources in the Be Informed repository
 */
export const RESOURCE_PATH = "/resource";

/**
 * Separator for parameters of a list, makes it possible to render multiple lists on a page in a non-js environment
 */
export const PARAMETER_SEPARATOR = "~";

/**
 * Timeversion filter name
 */
export const TIMEVERSION_FILTER_NAME = "entryDate";

const PARAMETER_OVERVIEW_VIEWTYPE = "viewType";
/**
 * Parameter name for the viewtype toggle
 */
export const DEFAULT_UI_PARAMETERS: Array<string> = [
  PARAMETER_OVERVIEW_VIEWTYPE,
];

/**
 */
export const ISO_DATE_FORMAT = "yyyy-MM-dd";
/**
 */
export const ISO_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
/**
 */
export const ISO_TIME_FORMAT = "HH:mm:ss";
/**
 */
export const ISO_TIMESTAMP_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS";
/**
 * Offset format is appended to iso datetime and timestamp when isIncludeTimeOffsetInDateTimes = true
 */
export const DATETIME_OFFSET_FORMAT = "xxx";
/**
 * week starts on monday by default
 */
export const DEFAULT_WEEK_STARTS_ON = 1;

/**
 * first week indicated by the 1st of january
 */
export const DEFAULT_FIRST_WEEK_CONTAINS_DATE = 1;

/**
 * Key codes
 * @type {{SPACE: number, PAGE_DOWN: number, TAB: number, ARROW_RIGHT: number, ARROW_DOWN: number, ENTER: number, ARROW_UP: number, ARROW_LEFT: number, PAGE_UP: number, ESCAPE: number}}
 */
export const KEYCODES = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
};

/**
 * @type {boolean}
 */
export const IS_SYNC = typeof dataFetcher !== "undefined";
/**
 * @type {boolean}
 */
export const IS_SERVER = IS_SYNC;
/**
 * @type {boolean}
 */
// $FlowExpectedError[cannot-resolve-name]
export const IS_GRAALJS = typeof Graal !== "undefined";

/**
 * @type {{SUCCESS: string, ERROR: string, INFO: string, WARNING: string}}
 */
export const NOTIFICATION_TYPES = {
  SUCCESS: "SUCCESS",
  INFO: "INFO",
  WARNING: "WARNING",
  ERROR: "ERROR",
};

/**
 * SUPPORTED HTTP METHODS
 * @type {{POST: string, GET: string}}
 */
export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
};

export const PARAMETER_TYPES = {
  BODY: "bodyParameter",
  QUERY: "queryParameter",
};

/**
 * POSSIBLE MODULARUI STATUSSES
 * @type {{LOADING: string, ERROR: string, FINISHED: string}}
 */
export const MODULARUI_STATUS = {
  LOADING: "LOADING",
  FINISHED: "FINISHED",
  ERROR: "ERROR",
};

/**
 * POSSIBLE AUTOSAVE STATUSSES
 * @type {{START: string, FINISHED: string}}
 */
export const AUTOSAVE_STATUS = {
  START: "START",
  FINISHED: "FINISHED",
};

/**
 * DEBOUNCE INPUT TIMEOUT
 */
export const INPUT_DEBOUNCE_TIMEOUT = 100;

/**
 * DEBOUNCE VALIDATION TIMEOUT
 */
export const VALIDATE_DEBOUNCE_TIMEOUT = 500;

/**
 * ATTRIBUTE WIDTH
 */
export const ATTRIBUTE_WIDTH = {
  EXTRA_SMALL: "EXTRA_SMALL",
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
  EXTRA_LARGE: "EXTRA_LARGE",
};

export const ALL_CONTENT_IN_DATA_SETTING = "hasAllContentInData";

export const INCLUDE_TIME_OFFSET = "isIncludeTimeOffsetInDateTimes";

export const INTERNAL_LOGIN_TYPE = {
  JAAS: "JAAS",
  PAC4J_FORM: "PAC4J_FORM",
  PAC4J_BASIC: "PAC4J_BASIC",
  PAC4J_INDIRECT: "PAC4J_INDIRECT",
};
export const LOGIN_TYPE = "security.clients";
export const LOGIN_PATH_SETTING = "FormClient.login_url";
export const LOGIN_USERNAME_SETTING = "FormClient.username_field_name";
export const LOGIN_PASSWORD_SETTING = "FormClient.password_field_name";
export const LOGOUT_PATH_SETTING = "FormClient.logout_url";

export const DEFAULT_AUTHENTICATION_TYPE = {
  name: "Form based authentication",
  authentication: "DefaultFormClient",
  isPrimary: true,
};
